enum VehicleStatus {
  EXPECTED = 10,
  CHECKED_IN = 20,
  CHECKED_IN_NEW = 200,
  READY_FOR_PICKUP = 30,
  PICKED_UP = 40,
}

export default VehicleStatus;

export const VEHICLE_STATUS_TRANSITIONS = {
  [VehicleStatus.EXPECTED]: [
    VehicleStatus.CHECKED_IN,
    VehicleStatus.CHECKED_IN_NEW,
    VehicleStatus.READY_FOR_PICKUP,
  ],
  [VehicleStatus.CHECKED_IN]: [
    VehicleStatus.EXPECTED,
    VehicleStatus.READY_FOR_PICKUP,
  ],
  [VehicleStatus.READY_FOR_PICKUP]: [
    VehicleStatus.EXPECTED,
    VehicleStatus.CHECKED_IN,
    VehicleStatus.CHECKED_IN_NEW,
    VehicleStatus.PICKED_UP,
  ],
  [VehicleStatus.PICKED_UP]: [
    VehicleStatus.EXPECTED,
    VehicleStatus.CHECKED_IN,
    VehicleStatus.CHECKED_IN_NEW,
    VehicleStatus.READY_FOR_PICKUP,
  ],
};

export const VEHICLE_PRESENT_STATUSES = [VehicleStatus.CHECKED_IN, VehicleStatus.READY_FOR_PICKUP];
export const READY_VEHICLE_STATUSES = [VehicleStatus.READY_FOR_PICKUP, VehicleStatus.PICKED_UP];